import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import DepartmentDashboard from './DepartmentDashboard';
import OverviewDashboard from './OverviewDashboard';
import './Dashboard.css';

function Dashboard() {
  const [activeTab, setActiveTab] = useState('overview');
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const departmentsRef = collection(db, 'departments');
        const snapshot = await getDocs(departmentsRef);
        const departmentsList = snapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          .filter(department => department.status === 'active');
        setDepartments(departmentsList);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching departments:', error);
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  const tabs = [
    { id: 'overview', label: 'Overview' },
    ...departments.map(dept => ({
      id: dept.name.toLowerCase().replace(/\s+/g, '-'),
      label: dept.name
    }))
  ];

  const renderContent = () => {
    if (activeTab === 'overview') {
      return <OverviewDashboard departments={departments} />;
    }
    return <DepartmentDashboard department={activeTab} />;
  };

  if (loading) {
    return <div className="dashboard-container">Loading...</div>;
  }

  return (
    <div className="dashboard-container">
      <h1>Operations Dashboard</h1>
      
      <div className="dashboard-nav">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="dashboard-content">
        {renderContent()}
      </div>
    </div>
  );
}

export default Dashboard;